import { gql } from "@apollo/client";
export const ADMIN_WINERY_MEMBER_GROUP_UPDATE = gql `
  mutation AdminWineryUpdate($input: AdminWineryUpdateInput!) {
    AdminWineryUpdate(input: $input)
  }
`;
